import axios from "axios";

export default {
    getPrList() { 
        return axios.get(`/course/Study/getPrList`);
    }
}